<!--
  首頁特色機種元件 (舊的，2020版)。目前線上使用的是：themes\frontend\src\modules\home\Showcase.vue
  裡頭又使用了兩個元件，一個是Header；另一個是Motor
  元件說明：Header選單(pc & md選單)元件在：themes/frontend/src/modules/home/_header.vue。v-slot會覆蓋slot標籤的內容
  元件說明：Motor特色機種清單元件內版型在：ShowcaseMotor.vue
-->
<template>
  <div class="showcase" id="showcase">
    <!-- <div class="container container--header"> -->

    <Header class="sticky">
      <!-- 是否顯示風格選單 -->
      <template v-if="enableStyleFilter" #menu>
        <span :class="{ active: current.findBy == 'series' }" class="item" @click="current.findBy = 'series'">依產品系列</span>
        / <span :class="{ active: current.findBy == 'styles' }" class="item" @click="current.findBy = 'styles'">依產品風格</span>
      </template>

      <template #submenu>
        <!-- pc尺寸時會出現 -->
        <template v-for="{ name, motors } in series">
          <div v-if="motors.length !== 0" :key="name" :class="{ active: current.category == name }" class="item" @click="checkCategoryUrl(name)">
              {{ name }}
          </div>
        </template>
        <div class="item">
          <a href="https://www.kymco.com.tw/mobilityscooter/" target="_blank">代步車</a>
        </div>
      </template>
    </Header>
    <!-- </div> -->

    <!-- md尺寸時會出現 -->
    <div ref="sticky" class="sticky-mobile-category">
      <div v-viewport-condition="'< md'" class="container">
        <div class="mobile-category">
          <div class="category">
            {{ current.category }}
          </div>
          <div class="menu">
            <div class="label">
              <span>前往</span>
              <span class="divider" />
              <span>其他</span>
              <i class="icon-down" />
            </div>
            <select v-model="current.category" @change="checkCategoryUrl">
              <template v-for="{ name, motors } in series">
                <option v-if="motors.length !== 0" :key="name" :value="name">
                  {{ name }}
                </option>
              </template>
              <option>
                <a href="https://www.kymco.com.tw/mobilityscooter/" target="_blank">
                  代步車
                </a>
            </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- 特色機種清單 -->
    <div class="container">
      <div v-if="displayMotors.length" class="list">
        <div class="pure-g">
          <div class="pure-u-1 pure-u-md-1-2">
            <div class="grid grid--large">
              <Motor :key="motorMainGrid.id" class="motor" :motor="motorMainGrid" :ative="current.category" large />
            </div>
          </div>
          <div class="pure-u-1 pure-u-md-1-2">
            <div class="pure-g">
              <div v-for="motor in motorGrids" :key="motor.id" class="pure-u-1-2">
                <div class="grid">
                  <Motor class="motor" :motor="motor" :ative="current.category" />
                </div>
              </div>
            </div>
          </div>
          <div v-for="motor in motorGridsMore" :key="motor.id" class="pure-u-1-2 pure-u-md-1-4">
            <div class="grid">
              <Motor class="motor" :motor="motor" :ative="current.category" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './_header.vue'
import Motor from './_motor.vue'

export default {
  name: 'Showcase',
  components: {
    Header,
    Motor,
  },
  props: {
    styles: Array,
    series: Array,
    enableStyleFilter: Boolean,
  },
  data: function () {
    return {
      menuSeries: ['紅黃牌', '150-250', '125-135', '100-115', '電動車', '微型電動', 'ATV', '代步車'],
      menuStyles: this.styles.map((s) => s.name),
      current: {
        findBy: 'series',
        category: '125-135',
        scrollTop: 0,
      },
      prev: {
        category: '125-135',
      },
    }
  },
  computed: {
    categorizedMotors() {
      return [...this.styles, ...this.series].reduce((o, e) => ({ ...o, [e.name]: e.motors.sort(this.motorSorter) }), {})
    },
    displayMotors() {
      return this.categorizedMotors[this.current.category]
    },
    motorMainGrid() {
      return this.displayMotors[0]
    },
    motorGrids() {
      if (this.motorMainGrid.showcaseAd) {
        return this.displayMotors.slice(0, 4)
      } else {
        return this.displayMotors.slice(1, 5)
      }
    },
    motorGridsMore() {
      if (this.motorMainGrid.showcaseAd) {
        return this.displayMotors.slice(4)
      } else {
        return this.displayMotors.slice(5)
      }
    },
    currentStyles() {
      return this.foundMotors
        .map((m) => m.styleNames[0])
        .filter((f) => f)
        .filter((el, i, a) => i === a.indexOf(el))
        .slice(0, 3)
    },
    currentCategories() {
      let categories = []
      switch (this.current.findBy) {
        case 'series':
          categories = this.menuSeries
          break
        case 'styles':
          categories = this.menuStyles
          break
      }
      return categories
    },
    nextCategory() {
      const idx = this.currentCategories.indexOf(this.current.category)
      if (this.currentCategories[idx + 1]) {
        return this.currentCategories[idx + 1]
      } else {
        return this.currentCategories[0]
      }
    },
  },
  watch: {
    'current.findBy'(by) {
      switch (by) {
        case 'series':
          this.current.category = this.menuSeries[2]
          break
        case 'styles':
          this.current.category = this.menuStyles[0]
          break
      }
    },
  },
  mounted() {
    if (typeof window.Stickyfill === 'object') {
      window.Stickyfill.addOne(this.$refs.sticky)
    }
  },
  methods: {
    motorSorter(a, b) {
      return a.showcaseAd === null ? 1 : b.showcaseAd === null ? -1 : 0
    },
    checkCategoryUrl(event) {
      let categoryName = event
      if (typeof event == 'string') {
        this.current.category = categoryName
      } else {
        categoryName = event.currentTarget.value
      }
      const currentCategory = [...this.series, ...this.styles].find((c) => c.name === categoryName)
      if (currentCategory && currentCategory.url) {
        window.open(currentCategory.url)
        this.current.category = this.prev.category
      } else {
        this.prev.category = this.current.category
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
$colorActive = #27A7E1

line-limit($n = 2)
  overflow hidden
  text-overflow ellipsis
  display -webkit-box
  -webkit-line-clamp $n
  -webkit-box-orient vertical

.container
  overflow visible

.container--header
  position relative
  z-index 100
  @media (max-width 767px)
    background white

.list
  .grid
    position relative
    background #f6f6f6
    height 0
    padding-bottom calc(100% - 1rem)
    border-radius 20px
    margin-right 1rem
    margin-bottom 1rem
    &--large
      // width 100%
      height calc(100% - 1rem)
      // margin-bottom 0
    .motor
      position absolute
      left 0
      right 0
      bottom 0
      top 0
      padding-top 1.5em

.sticky-mobile-category
  position sticky
  position -webkit-sticky
  top 0px
  z-index 1000
  @media (max-width 767px)
    top 60px
    z-index 999

.mobile-category
  padding-top 2rem
  padding-bottom 2rem
  background white
  display flex
  align-items center
  white-space nowrap
  .category
    font-size 2.5rem
  .menu
    .label
      position absolute
      pointer-events none
      z-index 10
      top 5px
      left 5px
      bottom 5px
      right 5px
      padding 1rem .25rem 1rem 1rem
      background white
      display flex
      justify-content space-between
      align-items center
      .divider
        border-bottom 1px solid #999
        width auto
        margin 1rem
        flex-grow 1
    margin-left auto
    border 1px solid #DDD
    background white
    position relative
    padding .25rem 1rem
    height 3rem
    width 200px
    box-sizing border-box
    select
      appearance none
      position absolute
      text-align-last right
      padding .25rem 1rem
      left 0
      top 0
      bottom 0
      width 100%
      border none

.showcase
  overflow visible !important
  user-select none
  padding-bottom 0px
  font-family '微軟正黑體'
  @media (min-width 768px)
    padding-top 45px
  @media (max-width 767px)
    padding-bottom 0rem
  .list
    margin-bottom 2rem
    margin-right -1rem

#showcaseInfo
  height 895px
</style>
